import { Injectable, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { AuthResult } from "../class/auth/auth-result";
import { AuthUser } from "../class/auth/auth-user";
import { HttpClient } from "@angular/common/http";
import { ApiService, RequestMethod } from "./api.service";
import { Collaborator } from '@feature-module/user/model/collaborator';

@Injectable({
  providedIn: "root",
})
export class AuthService extends ApiService implements OnDestroy {
  constructor(http: HttpClient) {
    super(http);
  }

  authUser(authUser: AuthUser): Observable<AuthResult> {
    return this.sendRequest<AuthResult>(
      "/api/auth/authenticate",
      RequestMethod.POST,
      authUser
    );
  }

  loggedUser(): Observable<Collaborator> {
    return this.sendRequest<Collaborator>("/user/me", RequestMethod.GET);
  }

  ngOnDestroy(): void {}
}
